import { render, staticRenderFns } from "./comPoup.vue?vue&type=template&id=2efd618a&"
import script from "./comPoup.vue?vue&type=script&lang=js&"
export * from "./comPoup.vue?vue&type=script&lang=js&"
import style0 from "./comPoup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports